"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNonExcludeCollections = void 0;
function getNonExcludeCollections(current, excluded, key) {
    if (!excluded.length) {
        return current;
    }
    const removedIds = excluded.map((item) => item[key]);
    return current.filter((item) => !removedIds.includes(item[key]));
}
exports.getNonExcludeCollections = getNonExcludeCollections;
//# sourceMappingURL=getNonExcludeCollections.js.map